<script setup lang="ts">
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import ExportExcelFile from '@/components/modal/utils/ExportExcelFile.vue';
import ImportFileModal from '@/components/modal/ImportFileModal.vue';

const props = defineProps<{
  exportRole: boolean;
  importRole: boolean;
  revertRole: boolean;
  sheetsData?: any[];
  sheetColumnStyle?: any[];
  fileName?: string;
  urlUpload?: string;
  importLabel?: string;
}>();

const emits = defineEmits<{
  clearFilter: [];
  onApply: [data: any];
  showRevertVersion: [];
}>();

const dialog = useDialog();

const clearFilter = () => {
  emits('clearFilter');
};

const showModalImportExcel = () => {
  const dialogRef = dialog.open(ImportFileModal, {
    props: {
      header: props.importLabel,
      modal: true
    },
    data: {
      url: props.urlUpload
    },
    emits: {
      onApply: (data: any, file: any) => {
        emits('onApply', { data, file });
        dialogRef.close();
      },
      onClose: () => {
        dialogRef.close();
      }
    }
  });
};

const showRevertVersion = () => {
  emits('showRevertVersion');
};
</script>

<template>
  <div class="flex justify-content-left gap-3 action-buttons">
    <Button id="btn-clear-filter" icon="pi pi-filter-slash" class="p-button-secondary mb-2" :label="$t('common.buttons.clear')" @click="clearFilter()" />
    <div v-if="exportRole">
      <ExportExcelFile id="btn-export-excel" class="export" :sheets="sheetsData" :columnsStyle="sheetColumnStyle" :file-name="fileName"></ExportExcelFile>
    </div>
    <div v-if="importRole">
      <Button id="btn-import-excel" :label="$t('common.buttons.import')" class="import-button" @click="showModalImportExcel()" />
    </div>
    <div v-if="revertRole">
      <Button id="btn-revert-excel" :label="$t('common.buttons.revert')" class="p-button-primary" @click="showRevertVersion()" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.export {
  :deep() {
    .p-button {
      background-color: #00af87;
      .p-button-icon {
        display: none;
      }
    }
  }
}
.import-button {
  background-color: #0c08e9;
}

.import-button:enabled:hover {
  background-color: #0c08e9;
}
</style>
